import { keys } from 'lodash';
import { types as t } from 'mobx-state-tree';
import { useCreateStore, useProvider, useStore } from 'mobx-store-provider';
import * as React from 'react';

const RecentFilterOption = t.model('RecentFilterOption', {
  level: t.maybeNull<any>(t.string),
  topicId: t.maybeNull<any>(t.string),
});

export const RecentNewsFilterStore = t
  .model('RecentNewsFilterStore', {
    filter: t.optional(RecentFilterOption, {}),
    drawerFilter: t.optional(RecentFilterOption, {}),
  })
  .views((self) => ({
    get filterKeys() {
      return keys(self.filter)
        .map((k) => {
          const value = self.filter[k];
          if (value) {
            return { key: k, value };
          }
          return null;
        })
        .filter(Boolean);
    },
  }))
  .actions((self) => ({
    clearSingleFilter(key) {
      self.filter[key] = null;
      self.drawerFilter[key] = null;
    },
    updateDrawerFilter(data) {
      keys(data).forEach((k) => {
        self.drawerFilter[k] = data[k];
      });
    },
    applyFilter() {
      keys(self.drawerFilter).forEach((k) => {
        self.filter[k] = self.drawerFilter[k];
      });
    },
    clearDrawerFilter() {
      keys(self.drawerFilter).forEach((k) => {
        if (self.drawerFilter[k]) {
          self.drawerFilter[k] = null;
        }
      });
    },
    clearFilter() {
      keys(self.drawerFilter).forEach((k) => {
        if (self.drawerFilter[k]) {
          self.drawerFilter[k] = null;
          self.filter[k] = null;
        }
      });
    },
  }));

export const useRecentNewsFilterStore = () => {
  return useStore(RecentNewsFilterStore);
};

export const withRecentNewsFilterStore = (Component: any) => (props: any) => {
  const dolEditorCreateStore = useCreateStore(RecentNewsFilterStore, {});
  const RecentNewsFilterStoreProvider = useProvider(RecentNewsFilterStore);

  return (
    <RecentNewsFilterStoreProvider value={dolEditorCreateStore}>
      <Component {...props} />
    </RecentNewsFilterStoreProvider>
  );
};
